export enum JobOfferStatus {
	ACCEPTED = 'Accepted',
	PENDING = 'Pending',
	REJECTED = 'Rejected',
	WITHDRAWN = 'Withdrawn'
}
